<template>
  <div id="app" v-if="stationData">
    <wrapper v-bind:heading="stationData.heading" nr="1" hideback>
      <p slot="intro">{{stationData.intro_text}}</p>
      <transition name="fade" appear>
        <div class="content__inner">
          <component
            :is="currentComponent"
            :stationData="stationData"
            :startTime="startTime"
            v-on:introEnded="introEnded"
          />
        </div>
      </transition>
    </wrapper>
  </div>
</template>

<script>
import {Howl, Howler} from 'howler';
import i18n from './i18n';
import axios from 'axios';
import Wrapper from 'ne01-common/src/components/Wrapper';
import Intro from './components/Intro.vue'
import BirdSearch from './components/BirdSearch.vue'

export default {
  name: 'app',
  components: {
    Wrapper,
    Intro,
    BirdSearch
  },
  mounted() {
    if(!window.apiUrl) window.apiUrl = 'https://lasauge.bird-song.ch';
    if(!window.cmsUrl) window.cmsUrl = 'https://wp.ls.bird-song.ch';
    if(!window.cmsSlug) window.cmsSlug = 'station-1';

    const visitorId = new URL(window.location.href).searchParams.get('visitor') || 1;
    const lang = new URL(window.location.href).searchParams.get('lang') || 'de';
    i18n.locale = lang;

    this.startTime = Date.now();

    this.loadData();
  },
  data: () => {
    return {
      currentComponent: 'Intro',
      stationData: null,
      startTime: 0
    }
  },
  methods: {
    introEnded() {
      this.currentComponent = 'BirdSearch';
    },
    loadData() {
      let url = `${window.cmsUrl}/wp-json/wp/v2/stations?slug=${window.cmsSlug}&lang=${i18n.locale}`;
      return new Promise((resolve, reject) => {
        axios.get(url)
          .then((response) => {
            this.stationData = response.data[0];
            resolve();
          });
      });
    },
  }
}
</script>

<style lang="scss">
#app {
  // font-family: 'GT Sectra', Helvetica, Arial, sans-serif;
  font-size: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
}
.content__inner {
  background-color: #0a0c0f;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
